<template>
  <a-modal
    :visible="visible"
    :width="560"
    centered
    :closable="false"
    :mask-closable="false"
    :footer="null"
    wrap-class-name="program-migrated-modal"
    @cancel="closeModal"
  >
    <section class="migrated-modal" aria-labelledby="program-migrated-title">
      <header class="migrated-modal__header">
        <span class="migrated-modal__label">Informasi Penting</span>
        <h2 id="program-migrated-title">Program Telah Dialihkan</h2>
      </header>

      <div class="migrated-modal__body">
        <p>
          Mohon maaf Anda tidak dapat mengajukan Program PULIH untuk terapi
          <strong>{{ normalizedProgramName }}</strong>.
        </p>
        <p>
          Program tersebut telah dialihkan menggunakan aplikasi <strong>PULIH 2.0</strong> yang
          dapat diunduh dari <strong>App Store</strong> dan <strong>Google Play Store</strong>.
        </p>

        <address class="migrated-modal__contact">
          <span>Ada pertanyaan seputar migrasi program? Hubungi CS IQVIA:</span>
          <a href="tel:+6281574584552">+62 815-7458-4552</a>
          <a href="mailto:pulih2customer.support@psplink.com">
            pulih2customer.support@psplink.com
          </a>
        </address>

        <a-button type="primary" size="large" block @click="closeModal">Mengerti</a-button>
      </div>
    </section>
  </a-modal>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'ProgramMigratedModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    programName: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const normalizedProgramName = computed(() => props.programName.trim().toUpperCase())
    const closeModal = () => emit('close')

    return {
      closeModal,
      normalizedProgramName,
    }
  },
}
</script>

<style lang="scss" scoped>
:global(.program-migrated-modal .ant-modal-content) {
  overflow: hidden;
  border-radius: 24px;
  box-shadow: 0 24px 70px rgba(25, 3, 27, 0.32);
}

:global(.program-migrated-modal .ant-modal-body) {
  padding: 0;
}

.migrated-modal {
  color: #432447;
  background: #ffffff;

  &__header {
    padding: 36px 38px 30px;
    color: #ffffff;
    background: linear-gradient(135deg, #4f125f 0%, #3b094b 100%);

    h2 {
      margin: 18px 0 0;
      color: #ffffff;
      font-size: 28px;
      font-weight: 700;
      line-height: 1.25;
    }
  }

  &__label {
    display: inline-flex;
    padding: 7px 14px;
    color: #ffffff;
    background: rgba(190, 91, 213, 0.32);
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    line-height: 1;
    text-transform: uppercase;
  }

  &__body {
    padding: 34px 38px 38px;

    p {
      margin: 0 0 24px;
      font-size: 17px;
      line-height: 1.65;
    }

    strong {
      color: #32143b;
      font-weight: 800;
    }

    :deep(.ant-btn-primary) {
      height: 58px;
      background: #4f125f;
      border-color: #4f125f;
      border-radius: 12px;
      box-shadow: 0 6px 14px rgba(79, 18, 95, 0.2);
      font-size: 18px;
      font-weight: 700;
      transition: background-color 180ms ease, border-color 180ms ease, box-shadow 180ms ease;

      &:hover,
      &:focus {
        background: #661773;
        border-color: #661773;
        box-shadow: 0 7px 18px rgba(79, 18, 95, 0.28);
      }

      &:focus-visible {
        outline: 3px solid rgba(79, 18, 95, 0.28);
        outline-offset: 3px;
      }
    }
  }

  &__contact {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 6px 0 30px;
    padding: 20px 22px;
    background: #f5e8f8;
    border-radius: 14px;
    font-size: 15px;
    font-style: normal;
    line-height: 1.45;

    span {
      margin-bottom: 12px;
    }

    a {
      min-height: 30px;
      color: #7b174d;
      font-weight: 700;
      text-decoration: underline;
      text-underline-offset: 3px;
      overflow-wrap: anywhere;
    }
  }
}

@media (max-width: 575px) {
  :global(.program-migrated-modal .ant-modal) {
    width: auto !important;
    max-width: calc(100vw - 32px);
    margin: 16px auto;
  }

  :global(.program-migrated-modal .ant-modal-content) {
    border-radius: 20px;
  }

  .migrated-modal {
    &__header {
      padding: 27px 25px 24px;

      h2 {
        margin-top: 14px;
        font-size: 23px;
      }
    }

    &__body {
      padding: 27px 25px 28px;

      p {
        margin-bottom: 20px;
        font-size: 15px;
        line-height: 1.6;
      }

      :deep(.ant-btn-primary) {
        height: 52px;
        font-size: 16px;
      }
    }

    &__contact {
      margin-bottom: 24px;
      padding: 17px 18px;
      font-size: 14px;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .migrated-modal__body :deep(.ant-btn-primary) {
    transition: none;
  }
}
</style>
